import icon from "../../assets/icon.png";
import "./Launch.css";
import Footer from "../Footer";
import Header from "../Header";
import PageTransition from "../../PageTransition";

export default function ContentLaunch() {
  return (
    <>
      <Header visible mode="normal" />
                 <PageTransition>

      <section className="launch-container container-fluid">
        <div className="row align-items-center launch-row">
          
          {/* LEFT */}
          <div className="col-lg-4 launch-left">
            <h1 className="launch-title">
              <div className="launch-line">
                LET&apos;S <img src={icon} alt="icon" />
              </div>

              <p className="launch-line">GET IN</p>

              <span className="launch-highlight">TOUCH</span>
            </h1>

            <div className="launch-graphic"></div>
          </div>

          {/* RIGHT */}
          <div className="col-lg-6 launch-right justify-content-center">
            <p className="launch-item">
              <i className="fa-solid fa-envelope"></i>
              <span>2lightyear.work@gmail.com</span>
            </p>

            <p className="launch-item">
              <i className="fa-solid fa-phone"></i>
              <span>+91 982912519</span>
            </p>

            <p className="launch-item address">
              <i className="fa-solid fa-location-arrow"></i>
              <span>
                First floor, 127, Pandit Ji Mishra Marg, Near Krishna Heart
                Hospital, Santosh Nagar, Nirman Nagar, Brijlalpura, Jaipur,
                Rajasthan 302019
              </span>
            </p>
          </div>

        </div>
      </section>
</PageTransition>
      <Footer visible mode="normal" />
    </>
  );
}
